import { useEffect, useState } from "react";
import { hotTopics } from "@/mocks/gossip";

const navLinks = [
  { label: "今日瓜田", href: "#today" },
  { label: "实时热瓜榜", href: "#rank" },
  { label: "翻车档案", href: "#persons" },
  { label: "来龙去脉", href: "#timeline" },
  { label: "实锤图鉴", href: "#gallery" },
  { label: "网友现场", href: "#comments" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`sticky top-0 z-50 w-full transition-colors duration-300 ${
        scrolled
          ? "bg-[rgb(var(--paper))]/90 backdrop-blur-md border-b border-[rgb(var(--ink))]/10"
          : "bg-[rgb(var(--paper))]"
      }`}
    >
      {/* 顶部热搜跑马灯 */}
      <div className="border-b border-[rgb(var(--ink))]/8 bg-[rgb(var(--ink))] text-[rgb(var(--paper))]">
        <div className="mx-auto flex w-full max-w-[1280px] items-center gap-3 overflow-hidden px-4 py-1.5 md:px-6">
          <div className="flex shrink-0 items-center gap-1.5">
            <i className="ri-fire-fill h-3.5 w-3.5 flex items-center justify-center text-[rgb(244,63,94)]"></i>
            <span className="whitespace-nowrap text-[11px] font-semibold tracking-widest text-[rgb(239,232,219)]">
              实时热榜
            </span>
          </div>
          <div className="relative flex-1 overflow-hidden">
            <div className="flex w-max animate-ticker items-center gap-6">
              {[...hotTopics, ...hotTopics].map((t, i) => (
                <a
                  key={i}
                  href="#rank"
                  className="flex items-center gap-2 whitespace-nowrap text-[12px] text-[rgb(239,232,219)]/80 transition-colors hover:text-[rgb(244,63,94)]"
                >
                  <span className="h-1 w-1 rounded-full bg-[rgb(244,63,94)]/70"></span>
                  {t}
                </a>
              ))}
            </div>
          </div>
          <span className="hidden shrink-0 items-center gap-1.5 whitespace-nowrap text-[11px] text-[rgb(239,232,219)]/70 md:flex">
            <i className="ri-radar-line h-3.5 w-3.5 flex items-center justify-center"></i>
            全网收录 · 持续更新
          </span>
        </div>
      </div>

      {/* 主导航 */}
      <div className="mx-auto flex w-full max-w-[1280px] items-center justify-between gap-4 px-4 py-3 md:px-6">
        {/* 品牌 Logo：全页唯一 H1 */}
        <h1 className="m-0 flex items-center gap-2.5 leading-none">
          <a href="#top" className="flex items-center gap-2.5">
            <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-[rgb(var(--brand))] text-[rgb(var(--paper))]">
              <i className="ri-slice-fill h-5 w-5 flex items-center justify-center"></i>
            </span>
            <span className="flex flex-col justify-center leading-tight">
              <span className="font-display block text-[20px] font-black tracking-wide">
                吃瓜黑料
              </span>
              <span className="block text-[10px] tracking-[0.2em] text-[rgb(var(--ink-soft))]">
                看谁又翻车 · 吃瓜情报站
              </span>
            </span>
          </a>
        </h1>

        <nav className="hidden items-center gap-1 lg:flex">
          {navLinks.map((n) => (
            <a
              key={n.href}
              href={n.href}
              className="whitespace-nowrap rounded-md px-3 py-2 text-[14px] font-medium text-[rgb(var(--ink))]/75 transition-colors hover:bg-[rgb(var(--ink))]/5 hover:text-[rgb(var(--brand))]"
            >
              {n.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <div className="hidden items-center gap-2 rounded-full border border-[rgb(var(--ink))]/15 bg-white/60 py-1.5 pl-3 pr-1.5 md:flex">
            <i className="ri-search-line h-4 w-4 flex items-center justify-center text-[rgb(var(--ink-soft))]"></i>
            <input
              type="text"
              placeholder="搜索人物 / 事件"
              className="w-32 bg-transparent text-[13px] text-[rgb(var(--ink))] placeholder:text-[rgb(var(--ink-soft))]/60 outline-none"
            />
            <span className="whitespace-nowrap rounded-full bg-[rgb(var(--ink))] px-2.5 py-1 text-[11px] text-[rgb(var(--paper))]">
              搜瓜
            </span>
          </div>
          <a
            href="#comments"
            className="hidden items-center gap-1.5 whitespace-nowrap rounded-md bg-[rgb(var(--brand))] px-3.5 py-2 text-[13px] font-semibold text-[rgb(var(--paper))] transition-colors hover:bg-[rgb(var(--brand-deep))] sm:flex"
          >
            <i className="ri-chat-3-fill h-4 w-4 flex items-center justify-center"></i>
            加入围观
          </a>
          <button
            type="button"
            aria-label="菜单"
            onClick={() => setOpen((v) => !v)}
            className="flex h-9 w-9 items-center justify-center rounded-md border border-[rgb(var(--ink))]/12 text-[rgb(var(--ink))] lg:hidden"
          >
            <i className={`${open ? "ri-close-line" : "ri-menu-line"} h-5 w-5 flex items-center justify-center`}></i>
          </button>
        </div>
      </div>

      {/* 移动端菜单 */}
      {open && (
        <nav className="border-t border-[rgb(var(--ink))]/8 bg-[rgb(var(--paper))] px-4 pb-4 pt-2 lg:hidden">
          <div className="grid grid-cols-2 gap-1">
            {navLinks.map((n) => (
              <a
                key={n.href}
                href={n.href}
                onClick={() => setOpen(false)}
                className="rounded-md px-3 py-2.5 text-[14px] font-medium text-[rgb(var(--ink))]/80 hover:bg-[rgb(var(--ink))]/5 hover:text-[rgb(var(--brand))]"
              >
                {n.label}
              </a>
            ))}
          </div>
        </nav>
      )}
    </header>
  );
}